// 接口地址
export const BASE_URL = process.env.VUE_APP_BASE_URL

// 媒体查询枚举
export const MediaQueryEnum = {
    'screen-xs': {
        maxWidth: 575
    },
    'screen-sm': {
        minWidth: 576,
        maxWidth: 767
    },
    'screen-md': {
        minWidth: 768,
        maxWidth: 991
    },
    'screen-lg': {
        minWidth: 992,
        maxWidth: 1199
    },
    'screen-xl': {
        minWidth: 1200,
        maxWidth: 1599
    },
    'screen-xxl': {
        minWidth: 1600
    }
}

// 系统免鉴权白名单
export const WHITE_LIST = ['/login', '/registration', '/404', '/401','/500']

// 默认跳转路径
export const DEFAULT_REDIRECT_PATH = '/'

// 系统token key 名称
export const TOKEN_KEY = 'Admin-Token'

// token 有效期 （天）
export const TOKEN_TIME = 1

// 默认table 分页数量
export const DEFAULT_PAGES_SIZE = 10

// todo 临时权限管理
/**
 * 角色权限
 * @type {{ADMIN: [string, string, string, string], USER: [string, string, string, string, string]}}
 */
export const ROLE = {
    ADMIN: [],
    USER: []
}

/** 用户权限枚举
 * ——————————————————————————————————————————————*/
// 管理员
export const ROLE_ADMIN_ENUM = '1'
// 用户
export const ROLE_USER_ENUM = '0'
/**
 * 权限列表
 * @type {({label: string, value: string}|{label: string, value: string})[]}
 */
export const ROLE_USER_ENUM_LIST = [{
        label: '管理员',
        value: ROLE_ADMIN_ENUM
    },
    {
        label: '用户',
        value: ROLE_USER_ENUM
    }
]

export const SMS_COUNTDOWN_TIME = 60